import React, { ReactElement } from 'react';

interface HistoricalProjectsToggleProps {
	showHistoricalFiles: boolean;
	onToggle: () => void;
	isLoading?: boolean;
}

class HistoricalProjectsToggle extends React.Component<HistoricalProjectsToggleProps> {
	constructor(props: HistoricalProjectsToggleProps) {
		super(props);
	}

	render(): ReactElement {
		const { showHistoricalFiles, onToggle, isLoading = false } = this.props;
		
		return (
			<div className="historical-projects-toggle">
				<div className="text-start mt-3">
					<button 
						type="button"
						role="button"
						tabIndex={isLoading ? -1 : 0}
						className={`btn btn-link text-primary ${isLoading ? 'disabled' : ''}`}
						style={{ cursor: isLoading ? 'not-allowed' : 'pointer', textDecoration: 'none' }}
						onClick={isLoading ? undefined : onToggle}
						disabled={isLoading}
						aria-disabled={isLoading}
					>
						{isLoading ? (
							<>
								<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
								Loading...
							</>
						) : (
							showHistoricalFiles ? '- Hide Files for Historical Projects' : '+ Show Files for Historical Projects'
						)}
					</button>
				</div>
			</div>
		);
	}
}

export default HistoricalProjectsToggle;